module.exports = __webpack_public_path__ + "img/icon-youtube.af8b96d7.svg";